/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { injectIntl } from 'react-intl';

import GroupLogoAdd from 'components/images/GroupLogoAdd';
import { ImageButton } from 'components/common/Button';
import { I18nImage } from 'components/features/I18nTranslation'
import './GroupLogo.css';
import RevealDotsVertical from '../../images/RevealDotsVertical';
import GroupMetadata from 'models/GroupMetadata';

interface Props {
  onClick(): void;
  groupMetadata: any;
  style: object;
  size: string;
  BackupLogo?(): JSX.Element;
  hasDots: boolean;
  intl: any;
}
const GroupLogoTemplate = (props: Props) => {
  const { onClick, groupMetadata, style, size, BackupLogo, hasDots, intl } = props;
  const group = new GroupMetadata(groupMetadata);
  const hasIcon = group.imagesIcon.hasValue(intl.locale) || group.imagesIcon.hasValue();

  return (
    <ImageButton onClick={onClick} style={style}>
      {
        hasDots  && (
          <div className="cmp-grouplogo-dots">
            <RevealDotsVertical className="fill-color-gsMiddle" />
          </div>
        )
      }
      {
        hasIcon
        ? (
          <I18nImage data={group.imagesIcon.get()} className="cmp-grouplogo" width={size} height={size} />
        ) : (
          Boolean(BackupLogo)
          ? <BackupLogo />
          : <GroupLogoAdd />
        )
      }
    </ImageButton>
  );
}

export default injectIntl(GroupLogoTemplate);
